import Link from "next/link";
import { useRouter } from "next/router";
import { formatTitle } from "../../utils/formatTitle"; // Import the utility function
import styles from "./Breadcrumbs.module.css"; // Assuming you have some styles for breadcrumbs

export default function Breadcrumbs() {
  const router = useRouter();
  const slug = router.asPath; // Get the current URL path
  const slugParts = slug.split("/").filter(Boolean); // Split and remove empty parts

  // Limit breadcrumbs to 3 items deep
  const breadcrumbs = slugParts.slice(0, 3).map((_, index) => {
    const currentSlug = slugParts.slice(0, index + 1).join("/");
    return {
      slug: currentSlug,
      title: formatTitle(
        decodeURIComponent(currentSlug.split("/").pop() || ""),
      ), // Use formatTitle for human-readable titles
    };
  });

  return (
    <nav className={styles.breadcrumbs}>
      <ul>
        {breadcrumbs.map((breadcrumb, index) => (
          <li
            key={breadcrumb.slug}
            className={
              index < breadcrumbs.length - 1 ? styles.notLast : styles.last
            }
          >
            <Link href={`/${breadcrumb.slug}`}>
              {index < breadcrumbs.length - 1 ? (
                <>{breadcrumb.title}</>
              ) : (
                <h1>{breadcrumb.title}</h1>
              )}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
